import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPortal } from 'react-dom';
import './GlobalMenu.css';

const GlobalMenu = ({ className, inline = false }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = () => {
    setShowMenu(!showMenu);
  };

  const handleNavigation = (path) => {
    setShowMenu(false);
    navigate(path);
  };

  return (
    <>
      {/* Menu button */}
      <button
        className={`global-menu-button ${inline ? 'inline-mode' : ''} ${className}`}
        onClick={handleMenuClick}
      >
        <div className='menu-phone'><img src="/menu_data/phone_menu.png" alt="MENU" /></div>
        <div className='menu-desktop'>
          <span className="menu-icon">
            <img src="/menu_data/Group 8.svg" alt="MENU" />
          </span>
          <span className="menu-text">MENU</span>
        </div>
      </button>

      {/* Menu overlay - rendered as portal to document body */}
      {showMenu && createPortal(
        <div className={`global-menu-overlay open `}>
          <div className=" hidden md:flex global-menu-content">
            {/* Logo in top-left */}
            <div className="global-menu-logo">
              <img src="/home_data/section1/groub_logo.png" alt="Logo" />
            </div>

            {/* Social icons on left side */}
            <div className="global-social-icons">
              <div className="global-social-icon"><img src="/home_data/section1/Vector1.svg" alt="Facebook" /></div>
              <div className="global-social-icon"><img src="/home_data/section1/Vector2.svg" alt="Facebook" /></div>
              <div className="global-social-icon"><img src="/home_data/section1/Vector3.svg" alt="Facebook" /></div>
              <div className="global-social-icon"><img src="/home_data/section1/Vector4.svg" alt="Facebook" /></div>
              <div className="global-social-icon"><img src="/home_data/section1/Vector5.svg" alt="Facebook" /></div>
            </div>

            {/* Navigation menu on right side */}
            <nav className="global-menu-navigation d-flex">
              <ul>
                <li onClick={() => handleNavigation('/content')}>Content</li>
                <li onClick={() => handleNavigation('/about-us')}>About Us</li>
                <li onClick={() => handleNavigation('/team')}>The Team</li>
                <li onClick={() => handleNavigation('/contact')}>Contact Us</li>
                <li onClick={() => handleNavigation('/shop')}>Shop</li>
                <li onClick={() => handleNavigation('/hospitality')}>Hospitality</li>
                <li onClick={() => handleNavigation('/news')}>News</li>
              </ul>
            </nav>

            {/* Close button in top-right */}
            <button className="global-close-menu" onClick={handleMenuClick}>
              X CLOSE
            </button>
          </div>


          <div className="flex flex-col gap-10 md:hidden text-white">

            <div className="flex justify-between items-center w-full  p-6 border-b-[1px] border-white">
              {/* Logo with click */}
              <div className="w-20 cursor-pointer logo-container" >
                <img src="/header_data/img/Logo Homepage.svg" alt="GAME7 menu logo" />
              </div>

              {/* GlobalMenu */}
              <div className="mt-2">
                <button className=" " onClick={handleMenuClick}>
                  X CLOSE
                </button>
              </div>
            </div>

            <div className="flex flex-col gap-4 px-11 font-[PilatExtendedRegular] text-3xl ">
              
                <div  onClick={() => handleNavigation('/content')}>Content</div>
                <div onClick={() => handleNavigation('/about-us')}>About Us</div>

                <div onClick={() => handleNavigation('/team')}>The Team</div>
                <div onClick={() => handleNavigation('/contact')}>Contact Us</div>
                <div onClick={() => handleNavigation('/shop')}>Shop</div>
                <div onClick={() => handleNavigation('/hospitality')}>Hospitality</div>
                <div onClick={() => handleNavigation('/news')}>News</div>
        
            </div>



            <div className="flex flex-col gap-2 px-11">
              <div className="global-social-icon"><img src="/home_data/section1/Vector1.svg" alt="Facebook" /></div>
              <div className="global-social-icon"><img src="/home_data/section1/Vector2.svg" alt="Facebook" /></div>
              <div className="global-social-icon"><img src="/home_data/section1/Vector3.svg" alt="Facebook" /></div>
              <div className="global-social-icon"><img src="/home_data/section1/Vector4.svg" alt="Facebook" /></div>
              <div className="global-social-icon"><img src="/home_data/section1/Vector5.svg" alt="Facebook" /></div>
            </div>

          </div>


        </div>,
        document.body
      )}
    </>
  );
};

export default GlobalMenu;
